/* Label selector v2 interaction — wiring: snippets/bas-capsule-label-architecture.liquid */
(function () {
  var NEW_DEFAULT_TEXT = 'Choose your label';
  var OLD_DEFAULT_TEXT = '*Blank Label*';
  var ALLOWED_CHARS = /[^a-zA-Z0-9\-@&$*# ]/g;
  var MAX_LABEL_LENGTH = 20;
  var MODAL_CLASS_PREFIX = 'variant-label-modal';
  // Shared modal(s) can serve many capsule rows — only the opener may apply a pick.
  var activeOwnerByModalId = {};

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isIconValue(code, item) {
    if (item && item.isIcon) return true;
    var val = String(code || '');
    return val.indexOf('-icon') !== -1 || val.indexOf('_icon') !== -1;
  }

  function getIconUrl(item) {
    if (!item) return '';
    return item.iconUrl || item.url || '';
  }

  function buildSwatchButton(value, label, iconUrl, selected) {
    var selectedClass = selected ? ' selected' : '';
    if (iconUrl) {
      return (
        '<button type="button" class="' +
        MODAL_CLASS_PREFIX +
        '-icon-swatch' +
        selectedClass +
        '" data-modal-value="' +
        escapeHtml(value) +
        '">' +
        '<img src="' +
        escapeHtml(iconUrl) +
        '" alt="' +
        escapeHtml(label || value) +
        '" width="20" height="20" loading="lazy">' +
        '</button>'
      );
    }

    var display = label || value;
    if (window.isBlankCapsuleLabel && window.isBlankCapsuleLabel(value)) {
      display = label && !window.isBlankCapsuleLabel(label) ? label : 'Blank';
    } else if (String(value).trim() === OLD_DEFAULT_TEXT) {
      display = 'Blank';
    }

    return (
      '<button type="button" class="' +
      MODAL_CLASS_PREFIX +
      '-swatch' +
      selectedClass +
      '" data-modal-value="' +
      escapeHtml(value) +
      '">' +
      escapeHtml(display) +
      '</button>'
    );
  }

  function syncModalFromCatalog(modal) {
    if (!modal || modal.dataset.catalogSynced === 'true') return;

    var catalog = window.basCapsuleLabelCatalog || window.capsuleLabelCatalog;
    if (!catalog || !catalog.length) return;

    var body = modal.querySelector('.variant-label-modal-body');
    if (!body) return;

    // Keep Liquid-rendered groups (correct order, swatch markup, icon fallbacks).
    if (body.querySelector('.variant-label-modal-group')) {
      modal.dataset.catalogSynced = 'true';
      modal.dataset.catalogSource = 'liquid';
      return;
    }

    var groups = [];
    var groupMap = {};

    catalog.forEach(function (item) {
      var groupName = item.groupName || 'Labels';
      var groupOrder = item.groupOrder != null ? Number(item.groupOrder) : 9999;

      if (window.isBlankCapsuleLabel && (window.isBlankCapsuleLabel(item.code) || window.isBlankCapsuleLabel(item.name))) {
        groupName = 'No Label';
      } else if (window.isBlankCapsuleLabelGroupName && window.isBlankCapsuleLabelGroupName(groupName)) {
        groupName = 'No Label';
      }

      if (!groupMap[groupName]) {
        groupMap[groupName] = { name: groupName, order: groupOrder, items: [] };
        groups.push(groupMap[groupName]);
      } else if (groupOrder < groupMap[groupName].order) {
        groupMap[groupName].order = groupOrder;
      }

      groupMap[groupName].items.push(item);
    });

    groups.sort(function (a, b) {
      return (a.order != null ? a.order : 9999) - (b.order != null ? b.order : 9999);
    });

    var html = '';
    groups.forEach(function (group) {
      group.items.sort(function (a, b) {
        var orderA = a.order != null ? Number(a.order) : 9999;
        var orderB = b.order != null ? Number(b.order) : 9999;
        if (orderA !== orderB) return orderA - orderB;
        return (a.sortIndex || 9999) - (b.sortIndex || 9999);
      });

      html += '<div class="variant-label-modal-group" data-group-name="' + escapeHtml(group.name) + '">';
      html += '<div class="variant-label-modal-group-header">' + escapeHtml(group.name) + '</div>';
      html += '<div class="variant-label-modal-swatch-grid">';

      group.items.forEach(function (item) {
        var mapped = window.mapCapsuleCatalogEntryToOption
          ? window.mapCapsuleCatalogEntryToOption(item)
          : null;
        var value = mapped ? mapped.title : (item.code || item.value || '');
        var label = mapped ? mapped.displayTitle : (item.name || value);
        var iconUrl = mapped && mapped.url ? mapped.url : getIconUrl(item);
        html += buildSwatchButton(value, label, iconUrl, false);
      });

      html += '</div></div>';
    });

    if (html) {
      body.innerHTML = html;
      modal.dataset.catalogSynced = 'true';
      modal.dataset.catalogSource = 'metaobjects';
    }
  }

  function sanitizeLabel(str) {
    return str.replace(ALLOWED_CHARS, '').slice(0, MAX_LABEL_LENGTH);
  }

  function replaceDisplayText(item, text) {
    var firstText = item.childNodes[0];
    if (firstText && firstText.nodeType === 3) {
      firstText.textContent = text;
    } else {
      item.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = text;
      });
    }
  }

  function isModalVisible(modal) {
    return !!(modal && (modal.classList.contains('active') || modal.classList.contains('is-active')));
  }

  function setModalVisibility(overlay, modal, isOpen) {
    if (!overlay || !modal) return;

    ['active', 'is-active'].forEach(function (cls) {
      overlay.classList.toggle(cls, isOpen);
      modal.classList.toggle(cls, isOpen);
    });

    overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (!isOpen) {
      modal.style.transform = '';
      modal.style.transition = '';
      // Keep overlay intercepting briefly so the same tap/click cannot
      // hit the selectize underneath and reopen the sheet.
      overlay.style.pointerEvents = 'auto';
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      window.setTimeout(function () {
        if (overlay.classList.contains('is-active') || overlay.classList.contains('active')) return;
        overlay.style.pointerEvents = '';
        overlay.style.opacity = '';
        overlay.style.visibility = '';
      }, 350);
    } else {
      overlay.style.pointerEvents = '';
      overlay.style.opacity = '';
      overlay.style.visibility = '';
    }
  }

  function forceCloseModal(modalId, overlay, modal) {
    setActiveOwner(modalId, null);
    setModalVisibility(overlay, modal, false);
    document.body.style.overflow = '';
  }

  function getActiveOwner(modalId) {
    return activeOwnerByModalId[modalId] || null;
  }

  function setActiveOwner(modalId, owner) {
    if (!modalId) return;
    if (owner) activeOwnerByModalId[modalId] = owner;
    else delete activeOwnerByModalId[modalId];
  }

  function wireSharedModal(modalId, overlay, modal) {
    if (!modal || modal.dataset.labelModalWired === 'true') return;
    modal.dataset.labelModalWired = 'true';

    if (overlay) {
      overlay.addEventListener('click', function () {
        forceCloseModal(modalId, overlay, modal);
      });
    }

    var closeBtn = modal.querySelector('[data-label-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        forceCloseModal(modalId, overlay, modal);
      });
    }

    modal.addEventListener('click', function (event) {
      var target = event.target.closest('[data-modal-value]');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var value = target.getAttribute('data-modal-value');
      var owner = getActiveOwner(modalId);
      if (owner && typeof owner.selectValue === 'function') {
        owner.selectValue(value);
        return;
      }

      // Single or multi capsule: never leave the sheet stuck open.
      forceCloseModal(modalId, overlay, modal);
    });

    var startY = 0;
    var currentY = 0;
    var isDragging = false;

    modal.addEventListener(
      'touchstart',
      function (event) {
        var body = modal.querySelector('.variant-label-modal-body');
        if (body && body.scrollTop > 0 && body.contains(event.target)) return;
        startY = event.touches[0].clientY;
        isDragging = true;
        modal.style.transition = 'none';
      },
      { passive: true }
    );

    modal.addEventListener(
      'touchmove',
      function (event) {
        if (!isDragging) return;
        currentY = event.touches[0].clientY;
        var diff = currentY - startY;
        if (diff > 0) modal.style.transform = 'translateY(' + diff + 'px)';
      },
      { passive: true }
    );

    modal.addEventListener(
      'touchend',
      function () {
        if (!isDragging) return;
        isDragging = false;
        modal.style.transition = '';
        var diff = currentY - startY;
        if (diff > 100) {
          forceCloseModal(modalId, overlay, modal);
        } else if (isModalVisible(modal)) {
          modal.style.transform = 'translateY(0)';
        } else {
          modal.style.transform = '';
        }
        currentY = 0;
        startY = 0;
      },
      { passive: true }
    );
  }

  function removeLegacyDuplicateCheckbox(root) {
    var labelInner = root.querySelector('.label-inner');
    if (!labelInner) return;

    var modernCheckbox = labelInner.querySelector('[data-label-customize-checkbox]');
    if (!modernCheckbox) return;

    var legacyRow = labelInner.querySelector('#v2-customize-checkbox-row');
    if (legacyRow) legacyRow.remove();

    labelInner.querySelectorAll('#v2-customize-checkbox').forEach(function (legacyCheckbox) {
      if (!legacyCheckbox.hasAttribute('data-label-customize-checkbox')) {
        legacyCheckbox.remove();
      }
    });
  }

  function watchLegacyDuplicateCheckbox(root) {
    var labelInner = root.querySelector('.label-inner');
    if (!labelInner || labelInner.dataset.legacyCheckboxWatcher === 'true') return;
    labelInner.dataset.legacyCheckboxWatcher = 'true';

    var observer = new MutationObserver(function () {
      removeLegacyDuplicateCheckbox(root);
    });
    observer.observe(labelInner, { childList: true, subtree: true });
  }

  function initLabelSelector(root) {
    if (root.dataset.labelSelectorReady === 'true') return;
    root.dataset.labelSelectorReady = 'true';

    removeLegacyDuplicateCheckbox(root);
    watchLegacyDuplicateCheckbox(root);

    var modalId = root.dataset.modalId || 'variant-label-modal';
    var overlay = document.getElementById(modalId + '-overlay');
    var modal = document.getElementById(modalId);
    var selectEl = root.querySelector('select[data-type="label-value"]');
    // Must target the LABEL selectize only — color is often the first .selectize-control
    // in the same .label-block and must keep normal Selectize open behavior.
    var selectizeControl = null;
    if (selectEl) {
      if (
        selectEl.nextElementSibling &&
        selectEl.nextElementSibling.classList.contains('selectize-control')
      ) {
        selectizeControl = selectEl.nextElementSibling;
      } else if (selectEl.selectize && selectEl.selectize.$control && selectEl.selectize.$control[0]) {
        selectizeControl = selectEl.selectize.$control[0];
      } else if (selectEl.parentElement) {
        selectizeControl = selectEl.parentElement.querySelector('.selectize-control');
      }
    }
    var checkbox = root.querySelector('[data-label-customize-checkbox]');
    var customInputWrap = root.querySelector('[data-label-custom-input-wrap]');
    var customInput = root.querySelector('[data-label-custom-input]');
    var createBtn = root.querySelector('[data-label-custom-create-btn]');
    var customField = root.querySelector('[data-label-custom-field]');

    var userExplicitlyChoseBlank = false;
    var initialReplaceDone = false;
    var customizeActive = false;

    function getSelectize() {
      return selectEl && selectEl.selectize ? selectEl.selectize : null;
    }

    function getCurrentValue() {
      var inst = getSelectize();
      if (inst) return inst.getValue() || selectEl.value || '';
      return selectEl ? selectEl.value : '';
    }

    function applyChange() {
      if (!selectizeControl) return;
      var selectizeItems = selectizeControl.querySelectorAll(
        '.selectize-input .item[data-value="' + OLD_DEFAULT_TEXT + '"]'
      );
      if (!selectizeItems.length) return;

      selectizeItems.forEach(function (item) {
        var currentText = item.textContent.trim();
        if (userExplicitlyChoseBlank) {
          // Keep cart/display value as *Blank Label* (not the friendly "Blank" title).
          if (currentText !== OLD_DEFAULT_TEXT) {
            replaceDisplayText(item, OLD_DEFAULT_TEXT);
          }
        } else if (!initialReplaceDone || currentText === OLD_DEFAULT_TEXT || currentText === 'Blank') {
          replaceDisplayText(item, NEW_DEFAULT_TEXT);
          initialReplaceDone = true;
        }
      });
    }

    function toggleCreateBtn() {
      if (!customInput || !createBtn) return;
      var hasText = customInput.value.trim().length > 0;
      customInput.classList.toggle('has-text', hasText);
      createBtn.classList.toggle('is-visible', hasText);
    }

    function updateModalSelection(val) {
      if (!modal) return;
      modal.querySelectorAll('[data-modal-value]').forEach(function (el) {
        el.classList.toggle('selected', el.getAttribute('data-modal-value') === val);
      });
    }

    function closeModal() {
      if (getActiveOwner(modalId) === ownerApi) setActiveOwner(modalId, null);
      setModalVisibility(overlay, modal, false);
      document.body.style.overflow = '';
    }

    function openModal() {
      if (!overlay || !modal) return;
      setActiveOwner(modalId, ownerApi);
      updateModalSelection(getCurrentValue());
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        setModalVisibility(overlay, modal, true);
      });
    }

    function notifyLabelChange() {
      if (!selectEl) return;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      if (typeof window.updateLabels === 'function') {
        window.updateLabels(selectEl);
      }
    }

    function selectValue(value) {
      // Shared modal: only the capsule row that opened it may apply the pick.
      // Works for 1 capsule (btfcapsules single) and N capsules (set-of-7).
      if (getActiveOwner(modalId) !== ownerApi) return;

      try {
        var inst = getSelectize();
        if (inst) {
          if (value === OLD_DEFAULT_TEXT) {
            userExplicitlyChoseBlank = true;
          } else {
            userExplicitlyChoseBlank = false;
            initialReplaceDone = true;
          }

          var previousValue = inst.getValue();
          if (previousValue === value) {
            inst.setValue('', true);
          }
          inst.setValue(value, false);
          applyChange();
          notifyLabelChange();

          if (checkbox && checkbox.checked) {
            checkbox.checked = false;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } finally {
        // Always dismiss the sheet after a swatch tap, even if Selectize errors.
        closeModal();
      }
    }

    var ownerApi = {
      root: root,
      selectEl: selectEl,
      selectValue: selectValue,
      closeModal: closeModal,
      updateModalSelection: updateModalSelection
    };

    wireSharedModal(modalId, overlay, modal);

    function applyCustomLabel(text) {
      text = sanitizeLabel(text);
      if (!text) return;

      var inst = getSelectize();
      if (!inst) return;

      userExplicitlyChoseBlank = false;
      initialReplaceDone = true;

      if (customInput) customInput.value = text;
      toggleCreateBtn();

      // Live cart shape (Honeycomb + single):
      //   _Standard Bundle Label N / _Label = "customize"
      //   _Custom Bundle Label N / _Custom Label = typed text
      // Preview + CSTM pricing resolve the custom field when value is "customize".
      if (customField) customField.value = text;
      inst.setValue('customize', false);
      applyChange();

      window.setTimeout(function () {
        if (customField) {
          customField.value = text;
          customField.dispatchEvent(new Event('input', { bubbles: true }));
          customField.dispatchEvent(new Event('change', { bubbles: true }));
          customField.dispatchEvent(new Event('blur', { bubbles: true }));
        }
        notifyLabelChange();
      }, 0);
    }

    function interceptSelectize() {
      if (!selectizeControl || selectizeControl.dataset.modalIntercepted === 'true') return;
      selectizeControl.dataset.modalIntercepted = 'true';

      function handleOpen(event) {
        if (customizeActive) return;
        if (event.target.closest('[data-label-custom-input-wrap]')) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var inst = getSelectize();
        if (inst && inst.isOpen) inst.close();
        var dd = root.querySelector('.selectize-dropdown');
        if (dd) dd.style.display = 'none';
        openModal();
      }

      selectizeControl.addEventListener('mousedown', handleOpen, true);
      selectizeControl.addEventListener('click', handleOpen, true);
      selectizeControl.addEventListener('touchstart', handleOpen, true);
    }

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        customizeActive = checkbox.checked;

        if (customizeActive) {
          if (selectizeControl) selectizeControl.classList.add('is-hidden');
          if (customInputWrap) customInputWrap.classList.add('is-active');
          window.setTimeout(function () {
            if (customInput) customInput.focus();
          }, 50);
        } else {
          if (customInputWrap) customInputWrap.classList.remove('is-active');
          if (selectizeControl) selectizeControl.classList.remove('is-hidden');
          if (customInput) customInput.value = '';
          if (customField) {
            customField.value = '';
            customField.dispatchEvent(new Event('input', { bubbles: true }));
            customField.dispatchEvent(new Event('change', { bubbles: true }));
          }
          toggleCreateBtn();

          var inst = getSelectize();
          if (inst) inst.setValue(OLD_DEFAULT_TEXT, false);
          applyChange();
          notifyLabelChange();
        }
      });
    }

    if (customInput) {
      customInput.addEventListener('input', function () {
        var cleaned = sanitizeLabel(customInput.value);
        if (cleaned !== customInput.value) customInput.value = cleaned;
        toggleCreateBtn();
      });

      customInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          var text = customInput.value.trim();
          if (text) applyCustomLabel(text);
        }
      });

      // Same as Create: on blur with text, commit customize + refresh preview
      // (single capsules and Honeycomb / set-of-7 share this owner setup).
      customInput.addEventListener('blur', function () {
        var text = customInput.value.trim();
        if (!text) return;
        var inst = getSelectize();
        var alreadyApplied =
          inst &&
          inst.getValue() === 'customize' &&
          customField &&
          String(customField.value || '').trim() === text;
        if (alreadyApplied) return;
        applyCustomLabel(text);
      });
    }

    if (createBtn) {
      createBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var text = customInput ? customInput.value.trim() : '';
        if (text) applyCustomLabel(text);
      });
    }

    if (selectEl) {
      selectEl.addEventListener('change', function () {
        if (selectEl.value === OLD_DEFAULT_TEXT) {
          userExplicitlyChoseBlank = true;
        } else {
          userExplicitlyChoseBlank = false;
          initialReplaceDone = true;
        }
        applyChange();
        if (getActiveOwner(modalId) === ownerApi) {
          updateModalSelection(getCurrentValue());
        }
      });
    }

    function ensureDefaultBlankLabel() {
      var inst = getSelectize();
      if (!inst) return false;

      var current = (inst.getValue() || '').toString().trim();
      if (current) return true;

      if (!inst.options || !inst.options[OLD_DEFAULT_TEXT]) return false;

      // Start on *Blank Label* so ATC can enable and cart gets the canonical blank value.
      userExplicitlyChoseBlank = true;
      inst.setValue(OLD_DEFAULT_TEXT, false);
      applyChange();
      // Force visible item text to *Blank Label* if selectize used displayTitle "Blank".
      if (selectizeControl) {
        selectizeControl.querySelectorAll(
          '.selectize-input .item[data-value="' + OLD_DEFAULT_TEXT + '"]'
        ).forEach(function (item) {
          replaceDisplayText(item, OLD_DEFAULT_TEXT);
        });
      }
      notifyLabelChange();
      // Native + jQuery so theme Product updateCartButton re-enables ATC.
      if (selectEl) {
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.jQuery) {
          window.jQuery(selectEl).trigger('change');
          window.jQuery(root).trigger('change');
        }
      }
      return true;
    }

    function refresh() {
      applyChange();
      interceptSelectize();
      ensureDefaultBlankLabel();
    }

    refresh();

    if (selectizeControl) {
      var observer = new MutationObserver(function () {
        try {
          refresh();
        } catch (error) {}
      });
      observer.observe(selectizeControl, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    var selectizePoll = window.setInterval(function () {
      if (getSelectize()) {
        window.clearInterval(selectizePoll);
        refresh();
      }
    }, 100);

    window.setTimeout(function () {
      window.clearInterval(selectizePoll);
      ensureDefaultBlankLabel();
    }, 10000);
  }

  function boot() {
    var modal = document.getElementById('variant-label-modal');
    if (modal && modal.dataset.catalogDriven === 'true') {
      syncModalFromCatalog(modal);
      window.setTimeout(function () {
        syncModalFromCatalog(modal);
      }, 800);
    }
    document.querySelectorAll('[data-label-selector]').forEach(initLabelSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
